import store from '@/store';
import api from '@/api';
import moment from 'moment';
import i18nStore from './store';
import i18n from './i18n';
import element from '@/configured/element-ui';
import log from '@/configured/logger';
import { LANGUAGE_CONFIG } from '@/configured/languages/config';
import { writeStoredLocale } from '@/configured/locale-storage';

export default {
  i18n,
  loadLanguageAsync,
  store: i18nStore,
};

//////////

/**
 * Set the i18n language for the application.
 * Uses centralized language configuration to determine moment.js locale.
 *
 * @param {string} lang The language code (e.g., 'fr', 'it', 'es-ES')
 * @returns {string} The language code that was set
 */
function setI18nLanguage(lang) {
  const langConfig = LANGUAGE_CONFIG[lang];

  i18n.locale = lang;

  // Set moment.js locale from centralized config
  if (langConfig && langConfig.momentLocale) {
    moment.locale(langConfig.momentLocale);
  } else {
    log.warn(`No moment locale config found for: ${lang}, using 'en'`);
    moment.locale('en');
  }

  element.setLocale(lang);
  api.defaults.headers.common['Accept-Language'] = lang;
  store.dispatch(`${i18nStore.namespace}/setLanguage`, lang);
  document.querySelector('html').setAttribute('lang', lang);
  document.title = i18n.t('siteName');
  writeStoredLocale(lang);
  return lang;
}

function loadLanguageAsync(lang) {
  const normalizedLang = normalizeLanguage(lang);
  log.info(`Loading language: ${lang} -> ${normalizedLang}`);
  return store
    .dispatch(`${i18nStore.namespace}/loadLanguage`, normalizedLang)
    .then((data) => {
      return setI18nLanguage(normalizedLang);
    });
}

function normalizeLanguage(lang) {
  const currentLang = store.state[i18nStore.namespace]
    ? store.state[i18nStore.namespace].language
    : 'en';

  if (!lang) {
    return currentLang || 'en';
  }

  if (LANGUAGE_CONFIG[lang]) {
    return lang;
  }

  if (lang.startsWith('site') || lang.length > 10) {
    return currentLang || 'en';
  }

  return 'en';
}

// Todo: This is coming in the next release.
// When we recognize that a translation is not found, reload the language from the API.
// Vue.config.missingHandler = (lang, key, vm) => {
//   log.info('Missing', lang, key, vm);
// };
